import { fork } from 'redux-saga/effects'
import api from 'helpers/api'
import APISaga from './APISaga'
import Types from './Types'

const asyncTypes = (key) =>
  [Types[`${key}_ATTEMPT`], Types[`${key}_SUCCESS`], Types[`${key}_FAILURE`]]

export default function* root() {
  // Banner
  yield fork(APISaga(api.findBanners, asyncTypes('FIND_BANNERS')).watcher)
  yield fork(APISaga(api.saveBanner, asyncTypes('SAVE_BANNER')).watcher)
  yield fork(APISaga(api.removeBanner, asyncTypes('REMOVE_BANNER')).watcher)

  // Company
  yield fork(APISaga(api.findCompanies, asyncTypes('FIND_COMPANIES')).watcher)
  yield fork(APISaga(api.findCompanies, asyncTypes('FIND_COMPANY_OPTIONS')).watcher)

  // Giveaway
  yield fork(APISaga(api.findAllGiveaways, asyncTypes('FIND_ALL_GIVEAWAYS')).watcher)

  // Order
  yield fork(APISaga(api.findOrders, asyncTypes('FIND_ORDERS')).watcher)
  yield fork(APISaga(api.getCart, asyncTypes('GET_CART')).watcher)
  yield fork(APISaga(api.addToCart, asyncTypes('ADD_TO_CART')).watcher)
  yield fork(APISaga(api.saveCart, asyncTypes('SAVE_CART')).watcher)
  yield fork(APISaga(api.checkout, asyncTypes('CHECKOUT')).watcher)
  yield fork(APISaga(api.reorder, asyncTypes('REORDER')).watcher)

  yield fork(APISaga(api.findAllOrders, asyncTypes('FIND_ALL_ORDERS')).watcher)
  yield fork(APISaga(api.saveOrder, asyncTypes('SAVE_ORDER')).watcher)
  yield fork(APISaga(api.uploadInvoice, asyncTypes('UPLOAD_INVOICE')).watcher)
  yield fork(APISaga(api.createPackPdf, asyncTypes('CREATE_PACK_PDF')).watcher)
  yield fork(APISaga(api.createCwOrder, asyncTypes('CREATE_CW_ORDER')).watcher)

  // Payment
  yield fork(APISaga(api.findPayments, asyncTypes('FIND_PAYMENTS')).watcher)
  yield fork(APISaga(api.findAllPayments, asyncTypes('FIND_ALL_PAYMENTS')).watcher)
  yield fork(APISaga(api.savePayment, asyncTypes('SAVE_PAYMENT')).watcher)

  // Product
  yield fork(APISaga(api.findProducts, asyncTypes('FIND_HOME_PRODUCTS')).watcher)
  yield fork(APISaga(api.findProducts, asyncTypes('FIND_BEST_SELLING_PRODUCTS')).watcher)
  yield fork(APISaga(api.findProducts, asyncTypes('FIND_PROMOTIONAL_PRODUCTS')).watcher)
  yield fork(APISaga(api.findProducts, asyncTypes('FIND_GIVEAWAY_PRODUCTS')).watcher)
  yield fork(APISaga(api.findProducts, asyncTypes('FIND_PRICES')).watcher)
  yield fork(APISaga(api.findProducts, asyncTypes('FIND_PRODUCTS')).watcher)
  yield fork(APISaga(api.findAllProducts, asyncTypes('FIND_ALL_PRODUCTS')).watcher)
  yield fork(APISaga(api.findOneProduct, asyncTypes('FIND_ONE_PRODUCT')).watcher)
  yield fork(APISaga(api.importProducts, asyncTypes('IMPORT_PRODUCTS')).watcher)
  yield fork(APISaga(api.importTags, asyncTypes('IMPORT_TAGS')).watcher)
  yield fork(APISaga(api.importConfigs, asyncTypes('IMPORT_CONFIGS')).watcher)
  yield fork(APISaga(api.importStocks, asyncTypes('IMPORT_STOCKS')).watcher)
  yield fork(APISaga(api.importBIS, asyncTypes('IMPORT_BIS')).watcher)
  yield fork(APISaga(api.importFD, asyncTypes('IMPORT_FD')).watcher)
  yield fork(APISaga(api.saveProduct, asyncTypes('SAVE_PRODUCT')).watcher)
  yield fork(APISaga(api.findTags, asyncTypes('FIND_TAGS')).watcher)
  yield fork(APISaga(api.findRecommendations, asyncTypes('FIND_PRODUCT_RECOMMENDATIONS')).watcher)
  yield fork(APISaga(api.aggregateProducts, asyncTypes('AGGREGATE_PRODUCTS')).watcher)
  yield fork(APISaga(api.findProducts, asyncTypes('FIND_BIS_PRODUCTS')).watcher)

  yield fork(APISaga(api.findProductImages, asyncTypes('FIND_PRODUCT_IMAGES')).watcher)
  yield fork(APISaga(api.addProductImage, asyncTypes('ADD_PRODUCT_IMAGE')).parallelWatcher)
  yield fork(APISaga(api.removeProductImage, asyncTypes('REMOVE_PRODUCT_IMAGE')).watcher)

  // Promocode
  yield fork(APISaga(api.findAllPromocodes, asyncTypes('FIND_ALL_PROMOCODES')).watcher)
  yield fork(APISaga(api.findOnePromocode, asyncTypes('FIND_ONE_PROMOCODE')).watcher)
  yield fork(APISaga(api.addPromocode, asyncTypes('ADD_PROMOCODE')).watcher)
  yield fork(APISaga(api.savePromocode, asyncTypes('SAVE_PROMOCODE')).watcher)

  // Reward
  yield fork(APISaga(api.findAllRewards, asyncTypes('FIND_ALL_REWARDS')).watcher)
  yield fork(APISaga(api.findOneReward, asyncTypes('FIND_ONE_REWARD')).watcher)
  yield fork(APISaga(api.addReward, asyncTypes('ADD_REWARD')).watcher)
  yield fork(APISaga(api.saveReward, asyncTypes('SAVE_REWARD')).watcher)

  // User
  yield fork(APISaga(api.findUsers, asyncTypes('FIND_USERS')).watcher)
  yield fork(APISaga(api.findOneUser, asyncTypes('FIND_ONE_USER')).watcher)
  yield fork(APISaga(api.saveUser, asyncTypes('EDIT_PROFILE')).watcher)
  yield fork(APISaga(api.saveUser, asyncTypes('SAVE_USER')).watcher)
  yield fork(APISaga(api.removeUser, asyncTypes('REMOVE_USER')).watcher)
  yield fork(APISaga(api.login, asyncTypes('LOGIN')).watcher)
  yield fork(APISaga(api.logout, asyncTypes('LOGOUT')).watcher)
  yield fork(APISaga(api.signup, asyncTypes('SIGNUP')).watcher)
  yield fork(APISaga(api.verify, asyncTypes('VERIFY')).watcher)
  yield fork(APISaga(api.findGiveaways, asyncTypes('FIND_GIVEAWAYS')).watcher)
  yield fork(APISaga(api.forgotPassword, asyncTypes('FORGOT_PASSWORD')).watcher)
  yield fork(APISaga(api.setNewPassword, asyncTypes('SET_NEW_PASSWORD')).watcher)
  yield fork(APISaga(api.notifyPayment, asyncTypes('NOTIFY_PAYMENT')).watcher)

  // Wishlist
  yield fork(APISaga(api.findWishlists, asyncTypes('FIND_WISHLIST')).watcher)
  yield fork(APISaga(api.addToWishlist, asyncTypes('ADD_TO_WISHLIST')).watcher)
  yield fork(APISaga(api.removeFromWishlist, asyncTypes('REMOVE_FROM_WISHLIST')).watcher)
}



/** WEBPACK FOOTER **
 ** ./src/redux/sagas.js
 **/